import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

import CTAButton from '../../../../components/CTAButton/CTAButton';
import Container from '../../../../components/Container/Container';
import ContentOverlay from '../../../../components/ContentOverlay/ContentOverlay';
import { PageType } from '../../../../types/ContentOverlay';

import { TXTWCL_Player_Funds_Protection } from './RMFPlayerFundsProtection.messages.json';
import PlayerFundsProtection from './components/PlayerFundProtection/PlayerFundsProtection';

const RMFPlayerFundsProtection: React.FC = () => {
  const [pageType, setPageType] = useState<PageType>();

  return (
    <Container
      page={RMFPlayerFundsProtection}
      headerProps={{ title: <Translation {...TXTWCL_Player_Funds_Protection} /> }}
      pageTopTitle={<Translation {...TXTWCL_Player_Funds_Protection} />}
    >
      <PlayerFundsProtection onPFPClick={() => setPageType(PageType.PFP)} />
      {pageType && <ContentOverlay pageType={pageType} onClose={() => setPageType(undefined)} />}
      <CTAButton />
    </Container>
  );
};

export default RMFPlayerFundsProtection;

RMFPlayerFundsProtection.displayName = 'RMFPlayerFundsProtection';
